import { Button } from "@components";
import { Image } from "@/components/ui/image";
import { IMAGES } from "../assets";
import { useChecklistProgressStore, useChecklistStore } from "../store";

export const ChecklistSuccess = () => {
	const clearChecklist = useChecklistStore((state) => state.clearChecklist);
	const setInitialState = useChecklistProgressStore(
		(state) => state.setInitialState
	);

	const handleFinishChecklist = () => {
		// Reseto os steps e o checklist
		setInitialState();
		clearChecklist();
	};

	return (
		<div className="mx-auto flex min-h-dvh w-full flex-col gap-5 bg-secondary pt-5">
			<div className="mx-auto w-full px-4">
				<div className="mx-auto flex w-full max-w-[456px] flex-col">
					<h5 className="font-bold text-secondary text-xl">
						Autovistoria concluída!
					</h5>
					<p className="text-sm text-tertiary">
						Está tudo certo com a sua vistoria. Caso tenha algum problema, entre
						em contato.
					</p>
				</div>
			</div>
			<div className="mx-auto flex h-full w-full flex-1 flex-col items-center gap-4 px-4">
				<Image
					alt="Autovistoria concluída!"
					className="my-auto"
					color="#9CA3AF"
					height={172}
					src={IMAGES.IllustrationSuccess}
					width={245}
				/>
			</div>

			<div className="sticky bottom-0 left-0 mt-auto w-full border-primary border-t bg-secondary px-4 pt-4 pb-8 text-center shadow-footer">
				<Button
					className="w-full max-w-[456px]"
					onClick={handleFinishChecklist}
					type="button"
				>
					Voltar para a tela inicial
				</Button>
			</div>
		</div>
	);
};
